import React, { Component } from "react";
// styles for page
import "./project_register_main.css";
// style for slider
import "slick-carousel/slick/slick.css";
// header for page
import ProjectRegisterHeader from "./project_register_main_header";
// request module
import axios from "axios";
// register pages
import RegStep1 from "./step1/reg_step1";
import RegStep2 from "./step2/reg_step2";
import RegStep3 from "./step3/reg_step3";
import RegStep4 from "./step4/reg_step4";
// icons for page
import Ionicon from "react-ionicons";
import { element } from "prop-types";

export default class ProjectRegister extends Component {
  constructor(props) {
    super(props);
    this.state = {
      step: 1,
      viewState: [1, 0, 0, 0],
      save: null,
      action: [null, null, null, null]
    };
  }
  componentDidMount = () => {
    document
      .getElementById("undo")
      .addEventListener("click", () => this.handleAction("undo"));
    document
      .getElementById("redo")
      .addEventListener("click", () => this.handleAction("redo"));
  };
  save = () => {
    this.setState(
      {
        save: this.state.step
      },
      this.savePrevent
    );
  };
  // prevent next actions
  savePrevent = () => {
    this.setState({
      save: null
    });
  };
  // change current views
  stepChangeHandle = nextStep => {
    if (nextStep == "back") {
      this.setState({
        step: this.state.step - 1
      });
    } else if (nextStep == "forward") {
      this.setState({
        step: this.state.step + 1
      });
    } else {
      this.setState({
        step: nextStep
      });
    }
  };
  //
  componentDidUpdate = () => {
    // window.scrollTo(0, 0);
  };
  componentWillUnmount = () => {
    window.localStorage.removeItem("logo");
    window.localStorage.removeItem("subdomain");
    document
      .getElementById("undo")
      .removeEventListener("click", () => this.handleAction("undo"));
    document
      .getElementById("redo")
      .removeEventListener("click", () => this.handleAction("redo"));
  };
  // subdomain
  submitSubDomain = event => {
    event.preventDefault();
  };
  // handle undo/redu
  handleAction = act => {
    let action = this.state.action;
    action[this.state.step - 1] = act;
    this.setState(
      {
        action
      },
      () => {
        setTimeout(this.clearActionState, 100);
      }
    );
  };
  // clear state
  clearActionState = () => {
    let action = this.state.action;
    for (let i = 0; i < action.length; i++) {
      action[i] = null;
    }
    this.setState({
      action
    });
  };
  render = () => {
    // check header arrow visibility
    let arrowStateArray = [null, null, this.state.step];
    if (this.state.step == 1) {
      arrowStateArray[0] = "disabledDiv";
    } else {
      arrowStateArray[0] = "";
    }
    if (this.state.step == 4) {
      arrowStateArray[1] = "disabledDiv";
    } else {
      arrowStateArray[1] = "";
    }
    let step = this.state.step;
    let array = null;
    let stepScreen = null;
    switch (step) {
      case 1:
        array = [1, 0, 0, 0];
        break;
      case 2:
        array = [0, 1, 0, 0];
        break;
      case 3:
        array = [0, 0, 1, 0];
        break;
      case 4:
        array = [0, 0, 0, 1];
        break;
      default:
        array = [1, 0, 0, 0];
    }
    // this.setState({
    //   viewState:array
    // })

    return (
      <div className="ProjMainRegister">
        <ProjectRegisterHeader
          step={this.state.step}
          stepChange={this.stepChangeHandle}
          title={this.state.subdomain}
          // getActions={this.getActions}
          stepNav={arrowStateArray}
          save={this.save}
        />
        <div className="stepRegBody">
          {/* {stepScreen} */}
          <RegStep1
            save={this.state.save}
            // change={this.stepChangeHandle}
            subdomain={this.state.subdomain}
            show={array[0]}
            step={this.stepChangeHandle}
            action={this.state.action[0]}
          />
          <RegStep2
            save={this.state.save}
            subdomain={this.state.subdomain}
            show={array[1]}
            step={this.stepChangeHandle}
            action={this.state.action[1]}
          />
          <RegStep3
            save={this.state.save}
            subdomain={this.state.subdomain}
            show={array[2]}
            step={this.stepChangeHandle}
            action={this.state.action}
            action={this.state.action[2]}
          />
          <RegStep4
            save={this.state.save}
            subdomain={this.state.subdomain}
            show={array[3]}
            step={this.stepChangeHandle}
            action={this.state.action[3]}
          />
        </div>
      </div>
    );
  };
}
